<template>
    <div class="flexContainer full">
        <section id="sectionPrincipal">
            <AdminTools></AdminTools>
            <section class="mobileNot">
                <section class="searchResultsWrapper tabletNot">
                    <section>
                        <div id="spinnerLoader" class="abs flexContainer" v-if="loading === true">
                            <Spinner :animation-duration="2500" :size="60" :color="'#41b4e8'" class="loader"></Spinner>
                        </div>
                        <ul class="nav nav-tabs primary-text">
                            <li v-for="(n, key) in componentTypeList" :key="key" class="liStyle" :class="{ liActive: n.name === type }">
                                <a href="#" class="componentLink uppercase" @click="openType(n.name);" :class="{}">{{ n.terms.name[$t("trad")] }}</a>
                            </li>
                            <li class="liStyle" :class="{ liActive: 'shades' === type }">
                                <a href="#" class="componentLink uppercase txtCenter" @click="openType('shades');">{{ $t("planobuilder.shades") }}</a>
                            </li>
                            <li class="liStyle" :class="{ liActive: 'plano' === type }">
                                <a href="#" class="componentLink uppercase txtCenter" @click="openType('plano');">plano</a>
                            </li>
                        </ul>
                        <br />
                        <button class="btn fright uppercase reactive" @click="saveReactive();">Re-active</button> <br />
                        <br />
                        <div class="sectionPrincipal primary-text">
                            <div
                                class="accordeon"
                                v-for="(m, index) in inactiveComponents"
                                :key="index"
                                v-if="m.type === type && Object.keys(inactiveComponents).length > 0"
                            >
                                <div>
                                    <table class="tableComponent">
                                        <tr>
                                            <td>
                                                <img
                                                    src="../../../static/img/no_image.jpg"
                                                    v-if="m.hasOwnProperty('figures') && m.figures.small === null"
                                                    width="100"
                                                    height="100"
                                                    class="rel"
                                                />
                                                <img
                                                    :src="getImgPath(m.figures.small, 'medium')"
                                                    v-if="m.hasOwnProperty('figures') && m.figures.small !== null"
                                                    width="100"
                                                    height="100"
                                                    class="rel"
                                                />
                                            </td>
                                            <td class="widthTD">
                                                <p class="componentName uppercase">{{ m.terms.name[$t("trad")]["value"] }}</p>
                                                <p
                                                    class="componentName"
                                                    v-if="
                                                        m.infosArticle.hasOwnProperty('diam_ref1') &&
                                                            m.infosArticle.diam_ref1.componentProperty.value !== '-'
                                                    "
                                                >
                                                    {{ m.infosArticle.diam_ref1.componentProperty.value }}
                                                </p>
                                                <p
                                                    class="componentName"
                                                    v-if="
                                                        (m.infosArticle.hasOwnProperty('diam_ref1') &&
                                                            m.infosArticle.diam_ref1.componentProperty.value === '-') ||
                                                            !m.infosArticle.hasOwnProperty('diam_ref1')
                                                    "
                                                >
                                                    No reference
                                                </p>
                                            </td>
                                            <td class="widthDeleted">
                                                <p class="componentName deletedBy">
                                                    Deleted by: {{ m.modifiedBy.firstname }} {{ m.modifiedBy.lastname }} at {{ m.modifiedDate }}
                                                </p>
                                            </td>
                                            <td><input type="checkbox" class="check" @change="reactivComponent(m.id, $event);" /></td>
                                        </tr>
                                    </table>
                                </div>
                                <br />
                            </div>
                        </div>
                        <div v-for="(n, index) in inactiveShades" :key="index" v-if="type === 'shades'" class="sectionPrincipal">
                            <table class="tableComponent">
                                <tr>
                                    <td><div class="circle" :style="'background:' + n.properties.colors.color['value']"></div></td>
                                    <td class="widthTD">
                                        <p class="shadeName uppercase">{{ n.name }}</p>
                                        <p class="shadeName" v-if="n.properties.hasOwnProperty('reference')">
                                            {{ n.properties.reference.client_ref1.value }}
                                        </p>
                                    </td>
                                    <td class="widthDeleted">
                                        <p class="shadeName deletedBy">Delete at: {{ n.modifiedDate }}</p>
                                    </td>
                                    <td><input type="checkbox" class="check" @change="reactivShades(n.id, $event);" /></td>
                                </tr>
                            </table>

                            <br />
                        </div>
                        <div v-for="(n, index) in inactivePlano" :key="index" v-if="type === 'plano'" class="sectionPrincipal">
                            <div>
                                <table class="tableComponentPlano">
                                    <tr>
                                        <td><img src="../../../static/assets/plano.png" width="50" height="80" class="rel" /></td>
                                        <td class="widthTD">
                                            <p class="componentName uppercase">{{ n.name }}</p>
                                        </td>
                                        <td class="widthDeleted">
                                            <p class="componentName">
                                                Deleted by: {{ n.modifiedBy.firstname }} {{ n.modifiedBy.lastname }} at {{ n.modifiedDate }}
                                            </p>
                                        </td>
                                        <td><input type="checkbox" class="check" @change="reactivPlano(n.id, $event);" /></td>
                                    </tr>
                                </table>
                            </div>
                            <br />
                        </div>
                    </section>
                </section>
            </section>
            <section class="mobileOnly mobile-warn">
                <div>{{ $t("common.mobileNotDispo") }}</div>
            </section>
        </section>
    </div>
</template>

<script>
import httpService from "../service";
import Globals from "../globals.js";
import AdminTools from "../adminTools/Admin";
import Spinner from "vue-simple-spinner";

export default {
    components: {
        AdminTools,
        Spinner
    },
    data: () => ({
        campaign: {},
        createStandDesign: false,
        inactiveComponents: {},
        componentTypeList: {},
        inactiveShades: {},
        inactivePlano: {},
        type: "module",
        display: false,
        saveObject: [],
        saveObjectShade: [],
        saveObjectPlano: [],
        loading: false
    }),
    watch: {},
    methods: {
        saveReactive() {
            let self = this;
            if (this.saveObject.length > 0) {
                let object = {
                    components: this.saveObject
                };
                let componentName = [];
                for (let i in this.inactiveComponents) {
                    for (let j in this.saveObject) {
                        if (this.inactiveComponents[i].id === this.saveObject[j]) {
                            componentName.push(this.inactiveComponents[i].terms.name[this.$t("trad")]["value"]);
                        }
                    }
                }
                self.$swal({
                    text: self.$t("messageError.reactiv") + "\n" + componentName,
                    type: "warning",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#41b4e8",
                    closeOnConfirm: true,
                    closeOnCancel: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showCancelButton: true,
                    cancelButtonText: "Cancel"
                }).then(result => {
                    this.loading = true;
                    httpService.put("/admin/components-activate", JSON.stringify(object)).then(response => {
                        httpService.get("/admin/components-inactive").then(resp => {
                            let checks = document.querySelectorAll("input.check");
                            checks.forEach(check => {
                                check.checked = false;
                            });
                            this.loading = false;
                            this.inactiveComponents = resp.data;
                        });
                    });
                });
            }
            if (this.saveObjectShade.length > 0) {
                let object = {
                    shades: this.saveObjectShade
                };
                let componentName = [];
                for (let i in this.inactiveShades) {
                    for (let j in this.saveObjectShade) {
                        if (this.inactiveShades[i].id === this.saveObjectShade[j]) {
                            componentName.push(this.inactiveShades[i].name);
                        }
                    }
                }
                self.$swal({
                    text: self.$t("messageError.shades") + "\n" + componentName,
                    type: "warning",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#41b4e8",
                    closeOnConfirm: true,
                    closeOnCancel: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showCancelButton: true,
                    cancelButtonText: "Cancel"
                }).then(result => {
                    this.loading = true;
                    httpService.put("/admin/shades-activate", JSON.stringify(object)).then(response => {
                        httpService.get("/admin/shades-inactive").then(response => {
                            let checks = document.querySelectorAll("input.check");
                            checks.forEach(check => {
                                check.checked = false;
                            });
                            this.inactiveShades = response.data;
                            this.loading = false;
                        });
                    });
                });
            }
            if (this.saveObjectPlano.length > 0) {
                let object = {
                    planos: this.saveObjectPlano
                };
                let componentName = [];
                for (let i in this.inactivePlano) {
                    for (let j in this.saveObjectPlano) {
                        if (this.inactivePlano[i].id === this.saveObjectPlano[j]) {
                            componentName.push(this.inactivePlano[i].name);
                        }
                    }
                }
                self.$swal({
                    text: self.$t("messageError.planos") + "\n" + componentName,
                    type: "warning",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#41b4e8",
                    closeOnConfirm: true,
                    closeOnCancel: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showCancelButton: true,
                    cancelButtonText: "Cancel"
                }).then(result => {
                    this.loading = true;
                    httpService.put("/admin/planos-activate", JSON.stringify(object)).then(response => {
                        httpService.get("/admin/planos-inactive").then(response => {
                            let checks = document.querySelectorAll("input.check");
                            checks.forEach(check => {
                                check.checked = false;
                            });
                            this.inactivePlano = response.data;
                            this.loading = false;
                        });
                    });
                });
            }
        },
        reactivComponent(id, event) {
            let checked = event.target.checked;
            if (checked === true) {
                this.saveObject.push(id);
            } else {
                this.saveObject.splice(this.saveObject.indexOf(id), 1);
            }
        },
        reactivShades(id, event) {
            let checked = event.target.checked;
            if (checked === true) {
                this.saveObjectShade.push(id);
            } else {
                this.saveObjectShade.splice(this.saveObjectShade.indexOf(id), 1);
            }
        },
        reactivPlano(id, event) {
            let checked = event.target.checked;
            if (checked === true) {
                this.saveObjectPlano.push(id);
            } else {
                this.saveObjectPlano.splice(this.saveObjectPlano.indexOf(id), 1);
            }
        },
        getImgPath(imgPath, format) {
            return Globals.getBaseUrl() + imgPath;
        },
        openType(type) {
            this.type = type;
            this.loading = true;
            if (
                type === "product" ||
                type === "module" ||
                type === "accessory" ||
                type === "peel-off" ||
                type === "other" ||
                type === "artworks" ||
                type === "structure"
            ) {
                httpService.get("/admin/components-inactive").then(response => {
                    this.inactiveComponents = response.data;
                    this.loading = false;
                });
            } else if (type === "shades") {
                httpService.get("/admin/shades-inactive").then(response => {
                    this.inactiveShades = response.data;
                    this.loading = false;
                });
            } else if (type === "plano") {
                httpService.get("/admin/planos-inactive").then(response => {
                    this.inactivePlano = response.data;
                    this.loading = false;
                });
            }
        }
    },
    created() {
        httpService.get("/admin/components-inactive").then(response => {
            this.inactiveComponents = response.data;
        });
        httpService.get("/admin/components/types?limit=1000&").then(response => {
            this.componentTypeList = response.data;
        });
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/themes";
.widthDeleted {
    width: 350px;
}
.check {
    margin-bottom: 32px;
    margin-left: 90px;
}
#spinnerLoader {
    background: rgba(255, 255, 255, 0.7);
    left: 0;
    width: 100%;
    height: 84%;
    .loader {
        position: absolute;
        top: 50%;
        left: 50%;
    }
}
.liStyle {
    text-align: center;
    padding: 17px;
}
.liActive {
    border-bottom: 2px black solid;
}
.saveReact {
    margin-right: 10px;
}
.nav-tabs {
    margin: 0;
    padding: 0;
}
.componentLink {
    @extend %primary-text;
    text-decoration: none;
    padding-bottom: 10px;
}
.accordeon {
}
.accordeonHidden {
    display: none;
}
.tableComponent {
    margin-left: 44px;
}
.tableComponentPlano {
    margin-left: 70px;
}
.widthTD {
    width: 350px;
}
.deletedBy {
    margin-bottom: 44px;
}
.shadeName {
    padding-left: 45px;
}
.circle {
    margin-left: 18px;
    border-radius: 50%;
    width: 45px;
    height: 45px;
    position: initial;
}
.componentName {
    padding-left: 30px;
}
.componentImg {
    margin-left: 40px;
}
.titleImg {
    display: inline-block;
}
.componentTitle {
    padding-left: 30px;
    font-size: 18px;
}
.btn-brand {
    margin: 1px;
}

.content-button {
    padding-right: 10px;
}
.componentSection {
    padding: 10px;
    margin-top: 10px;
    height: 45px;
    background-color: #e8e8e8;
}
.mobile-warn {
    padding: 10px 50px;
    margin-bottom: 10px;
    background-color: #7c3032;
    color: white;
    max-width: 400px;
}
</style>



// WEBPACK FOOTER //
// InactiveComponent.vue?5024cc3c